import { render, staticRenderFns } from "./ModalContentTicket.vue?vue&type=template&id=45ec5aa6&scoped=true&"
import script from "./ModalContentTicket.vue?vue&type=script&lang=js&"
export * from "./ModalContentTicket.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentTicket.vue?vue&type=style&index=0&id=45ec5aa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec5aa6",
  null
  
)

export default component.exports